<template>
  <section class="benefits-culture position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="benefits-header text-center">
            <div class="benefits-section-label">
              <h4>{{ content.header.label }}</h4>
            </div>
            <div class="benefits-main-title">
              <h2>{{ content.header.title }}</h2>
            </div>
            <div class="benefits-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="row">
        <div 
          v-for="(benefit, index) in content.benefits" 
          :key="index"
          class="col-lg-4 col-md-6 mb-4"
        >
          <div class="benefit-item">
            <div class="benefit-bg">
              <div class="block-shape-1"></div>
              <div class="block-shape-2"></div>
            </div>
            <div class="benefit-content">
              <div class="benefit-icon">
                <i :class="benefit.icon"></i>
              </div>
              <h3>{{ benefit.title }}</h3>
              <p>{{ benefit.description }}</p>
              <div class="benefit-features">
                <div 
                  v-for="(feature, featureIndex) in benefit.features" 
                  :key="featureIndex"
                  class="feature-item"
                >
                  <i class="icon-03"></i>
                  <span>{{ feature }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CareersBenefitsComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Benefits & Culture Section */
.benefits-culture {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.benefits-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.benefits-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.benefits-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.benefits-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.benefit-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.benefit-item:hover {
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.benefit-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.block-shape-1 {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, rgba(246, 236, 79, 0.1), rgba(246, 236, 79, 0.05));
  border-radius: 50%;
  opacity: 0.3;
}

.block-shape-2 {
  position: absolute;
  bottom: -30px;
  left: -30px;
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, rgba(246, 236, 79, 0.08), rgba(246, 236, 79, 0.03));
  border-radius: 50%;
  opacity: 0.4;
}

.benefit-content {
  position: relative;
  z-index: 2;
}

.benefit-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.benefit-icon i {
  font-size: 24px;
  color: #00061A;
}

.benefit-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.benefit-content p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 25px;
  line-height: 1.6;
}

.benefit-features {
  margin-bottom: 25px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.feature-item i {
  color: #F6EC4F;
  margin-right: 10px;
  font-size: 14px;
}

.feature-item span {
  color: #fff;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 767px) {
  .benefits-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .benefits-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .benefit-item {
    padding: 30px 20px;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .benefits-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
